/**
 * @description 项目组其他配置变量
 */
module.exports = {
  // 帆软地址
  frURL: 'https://finereport.yjljt.net.cn/decision/'
  // // 企业微信配置
  // cpConfig: {
  //   // 企业的CorpID
  //   appid: 'ww5dc963c00050f3e5',
  //   // 应用agentid，建议填上该参数（对于第三方应用和代开发自建应用，在填写该参数的情况下或者在工作台、聊天工具栏、应用会话内发起oauth2请求的场景中，会触发接口许可的自动激活）。snsapi_privateinfo时必填否则报错；
  //   agentid: '1000002',
  //   oauth2: {
  //     authorizationUrl: 'https://open.weixin.qq.com/connect/oauth2/authorize',
  //     // 授权后重定向的回调链接地址(空，系统自动处理)
  //     redirect_uri: 'http://uniedp.cn/#/my/bindUserOpen/cp',
  //     // 返回类型，此时固定为：code
  //     response_type: 'code',
  //     // 应用授权作用域。
  //     //        snsapi_base：静默授权，可获取成员的基础信息（UserId与DeviceId）；
  //     //        snsapi_privateinfo：手动授权，可获取成员的详细信息，包含头像、二维码等敏感信息。
  //     scope: 'snsapi_base',
  //     // 重定向后会带上state参数，企业可以填写a-zA-Z0-9的参数值，长度不可超过128个字节
  //     state: ''
  //   }
  // }
}
